import React from 'react';
import InvoicePartyDetailStep from './InvoicePartyDetailStep';

type Props = {
  onClose: () => void;
  onPrevious: () => void;
  onNext: () => void;
};

const BuyerDetailStep: React.FC<Props> = ({ onNext }) => (
  <InvoicePartyDetailStep party="buyer" onNext={onNext} />
);

export default BuyerDetailStep;
